import { render, staticRenderFns } from "./adv-slot.component.vue?vue&type=template&id=17c4e613&"
import script from "./adv-slot.component.vue?vue&type=script&lang=ts&"
export * from "./adv-slot.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports